import React, { useState, useEffect } from 'react';
import { Fab, Zoom } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

function ScrollToTopButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <Zoom in={visible}>
      <Fab
        onClick={scrollToTop}
        size="medium"
        aria-label="Subir al inicio"
        sx={{
          position: 'fixed',
          bottom: { xs: 96, sm: 100 },
          right: { xs: 16, sm: 24 },
          backgroundColor: '#600002',
          color: '#fff',
          zIndex: 1000,
          boxShadow: '0 4px 16px rgba(96,0,2,0.35)',
          '&:hover': {
            backgroundColor: '#E31C24',
            transform: 'translateY(-2px)',
            boxShadow: '0 6px 20px rgba(96,0,2,0.45)',
          },
          transition: 'background-color 0.2s, transform 0.2s, box-shadow 0.2s',
        }}
      >
        <KeyboardArrowUpIcon sx={{ fontSize: '1.6rem' }} />
      </Fab>
    </Zoom>
  );
}

export default ScrollToTopButton;
